import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('auth')
export default {
  computed: {

    ...mapGetters(['user', 'generalConfigs']),
    isShowUSDTAuto() {
      return this.generalConfigs?.features?.autoUSDTPayment?.status === 'available'
    },

    isOnlyEcomdyPlatform() {
      return this.isEcomdyPlatform
    },

    companyName() {
      return process.env.VUE_APP_COMPANY_NAME
    },

    platformName() {
      return process.env.VUE_APP_PLATFORM_NAME
    },

    isEcomdyPlatform() {
      return this.platformName === 'Ecomdy'
    },

    isAdreachPlatform() {
      return this.platformName === 'Adreach'
    },

    isPATIPlatform() {
      return this.platformName === 'PATI'
    },

    isSMBAgencyPlatform() {
      return this.platformName === 'SBH Media'
    },

    isDC3Platform() {
      return this.platformName === '3 Độ Agency'
    },

    isEmediaPlatform() {
      return this.platformName === 'Emedia'
    },

    isTeeXcorpPlatform() {
      return this.platformName === 'TeeXcorp'
    },

    isGyxenPlatform() {
      return this.platformName === 'Gyxen'
    },

    isGoodvibesPlatform() {
      return this.platformName === 'Goodvibes Agency'
    },

    isFinalArrowPlatform() {
      return this.platformName === 'Final Arrow'
    },

    isClickTechPlatform() {
      return this.platformName === 'ClickTech'
    },

    isTakiPlatform() {
      return this.platformName === 'DG'
    },

    isAdSolutions() {
      return this.platformName === 'Ad Solutions'
    },
    isDzairNova() {
      return this.platformName === 'Dzair Nova'
    },

    isBangladeshPlatform() {
      return this.platformName === 'Ecomdy Bangladesh'
    },

    isLeyaMedia() {
      return this.platformName === 'Leya Media'
    },

    isCholoSpeed() {
      return this.platformName === 'CholoSpeed'
    },

    isNoLimit() {
      return this.platformName === 'Nolimit Tiktokads'
    },

    isHaeGlobal() {
      return this.platformName === 'Hae Global'
    },

    isOPCreative() {
      return this.platformName === 'OP Creative'
    },

    convertPlatformName() {
      return this.isAdreachPlatform ? 'Adreach' : this.platformName
    },

    isVNWhiteLabel() {
      return this.isSMBAgencyPlatform || this.isDC3Platform || this.isTakiPlatform
    },

    logo() {
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO || require('@/assets/images/logo/logo.svg')
    },

    listMarket() {
      return process.env.VUE_APP_LIST_MARKET
    },

    /* ----- Docs ----*/

    servicePolicy() {
      return process.env.VUE_APP_SERVICE_POLICY
    },

    refundPolicy() {
      return process.env.VUE_APP_REFUND_POLICY
    },

    guideVerifyAccount() {
      return process.env.VUE_APP_GUIDE_TO_VERIFY_ACCOUNT
    },

    guideToTopUpBUSD() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_BUSD
    },

    guideToTopUpAirwallex() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_AIRWALLET
    },

    guideToTopUpLianLian() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_LIANLIAN
    },

    guideToTopUpCreditCard() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_CREDIT_CARD
    },

    activeYourCreditCard() {
      return process.env.VUE_APP_ACTIVE_YOUR_CREDIT_CARD
    },

    guideToTopUpPayoneer() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_PAYONEER
    },

    guideToTopUpPaypal() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_PAYPAL
    },

    guideToTopUpTazapay() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_TAZAPAY
    },

    guideToTopUpUSDT() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_USDT
    },

    guideToTopUpUSDTAuto() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_USDT_AUTO
    },

    guideToTopUpTransferWise() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_WISE
    },

    guideToTopUpPayfast() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_PAYFAST
    },

    guideToConnectTikTokAccount() {
      return process.env.VUE_APP_GUIDE_TO_CONNECT_TIKTOK_ACCOUNT
    },

    guideToCreateBusinessCenter() {
      return process.env.VUE_APP_GUIDE_TO_CREATE_BUSINESS_CENTER
    },

    guideToCreateAdAccount() {
      return process.env.VUE_APP_GUIDE_TO_CREATE_AD_ACCOUNT
    },

    guideToSubmitProductLink() {
      return process.env.VUE_APP_GUIDE_TO_SUBMIT_PRODUCT_LINK
    },

    guideToCancelSubscription() {
      return process.env.VUE_APP_GUIDE_TO_CANCEL_SUBSCRIPTION
    },

    guideToUpgradeSubscription() {
      return process.env.VUE_APP_GUIDE_TO_UPGRADE_SUBSCRIPTION
    },

    guideToDownloadInvoiceTopUp() {
      return process.env.VUE_APP_GUIDE_TO_DOWNLOAD_INVOICE_TOP_UP
    },

    guideToDownloadInvoiceSubscription() {
      return process.env.VUE_APP_GUIDE_TO_DOWNLOAD_INVOICE_SUBSCRIPTION
    },

    guideToAutoTopUpAdAccount() {
      return process.env.VUE_APP_GUIDE_TO_AUTO_TOP_UP_AD_ACCOUNT
    },

    autoTopUpAdAccountPolicy() {
      return process.env.VUE_APP_AUTO_TOP_UP_AD_ACCOUNT_POLICY
    },

    autoRefundPolicy() {
      return process.env.VUE_APP_AUTO_REFUND_POLICY
    },

    guideToTopUpLocalBank() {
      return process.env.VUE_APP_GUIDE_TO_TOP_UP_LOCAL_BANK
    },

    addressPartnership() {
      return process.env.VUE_APP_PARTNERSHIP_ADDRESS
    },

    officesPartnership() {
      return process.env.VUE_APP_PARTNERSHIP_OFFICES
    },

    phoneNumberPartnership() {
      return process.env.VUE_APP_PARTNERSHIP_PHONE_NUMBER
    },

    emailPartnership() {
      return process.env.VUE_APP_PARTNERSHIP_EMAIL_URL
    },

    facebookPartnership() {
      return process.env.VUE_APP_PARTNERSHIP_FACEBOOK_URL
    },

    instagramPartnership() {
      return process.env.VUE_APP_PARTNERSHIP_INSTAGRAM_URL
    },

    whatsAppPartnership() {
      return process.env.VUE_APP_PARTNERSHIP_WHATS_APP_URL
    },

    telegramPartnership() {
      return process.env.VUE_APP_PARTNERSHIP_TELEGRAM_URL
    },

    emailSupportPartnero() {
      return process.env.VUE_APP_PARTNERO_EMAIL_URL
    },

    whatsAppSupportPartnero() {
      return process.env.VUE_APP_PARTNERO_WHATS_APP_URL
    },

    larkSupportPartneroUrl() {
      return process.env.VUE_APP_PARTNERO_LARK_URL
    },

    facebookSupportPartneroUrl() {
      return process.env.VUE_APP_PARTNERO_FACEBOOK_URL
    },

    discordUrl() {
      return process.env.VUE_APP_DISCORD
    },

    telegramUrl() {
      return process.env.VUE_APP_TELEGRAM
    },

    instagramUrl() {
      return process.env.VUE_APP_INSTAGRAM
    },

    messengerUrl() {
      return process.env.VUE_APP_MESSENGER
    },

    whatsAppUrl() {
      return process.env.VUE_APP_WHATS_APP
    },

    supportUrl() {
      return process.env.VUE_APP_SUPPORT
    },

    termsOfService() {
      return process.env.VUE_APP_GUIDE_TERMS_OF_SERVICE
    },

    helpCenterLink() {
      return process.env.VUE_APP_HELP_CENTER
    },

    aboutUsLink() {
      return process.env.VUE_APP_ABOUT_US
    },

    /* ----- Download invoice ----*/
    hasShowInvoice() {
      return process.env.VUE_APP_SHOW_INVOICE === 'true'
    },

    /* ----- End Docs ----*/

    hasMaintainMode() {
      return process.env.VUE_APP_MAINTAIN_MODE === 'true'
    },

    // handle show/hide feature and page
    trialMode() {
      return process.env.VUE_APP_MODE_TRIAL === 'true'
    },

    subscriptionMode() {
      return process.env.VUE_APP_MODE_SUBSCRIPTION === 'true'
    },

    tipMode() {
      return process.env.VUE_APP_MODE_TIP === 'true'
    },

    refMode() {
      return process.env.VUE_APP_MODE_REF === 'true'
    },

    partnerShipMode() {
      return process.env.VUE_APP_MODE_PARTNERSHIP === 'true'
    },

    pixelMode() {
      return process.env.VUE_APP_MODE_PIXEL === 'true'
    },

    isVerifyEmailLater() {
      return process.env.VUE_APP_MODE_VERIFY_EMAIL === 'true'
    },

    showUserGuide() {
      return process.env.VUE_APP_SHOW_USER_GUIDE === 'true'
    },

    productLinkMode() {
      return process.env.VUE_APP_MODE_PRODUCT_LINK === 'true'
    },

    autoTopUpAdAccountMode() {
      return process.env.VUE_APP_MODE_AUTO_TOPUP_AD_ACCOUNT === 'true'
    },

    refundMode() {
      return process.env.VUE_APP_MODE_REFUND === 'true'
    },

    refundAutoMode() {
      return process.env.VUE_APP_MODE_REFUND_AUTO === 'true'
    },

    affiliateProgramMode() {
      return process.env.VUE_APP_PARTNERO_ID
    },

    // navbar
    showAppHelpCenterComponent() {
      return process.env.VUE_APP_SHOW_APP_HELP_CENTER === 'true'
    },

    loginUrl() {
      return process.env.VUE_APP_LOGIN_URL
    },

    partneroLoginUrl() {
      return process.env.VUE_APP_PARTNERO_LOGIN_URL
    },

    isShowNotification() {
      return process.env.VUE_APP_NOTIFICATION === 'true'
    },

    isShowSmartFeature() {
      return this.user?.data?.isWhitelistUSPC
    },
  },

  methods: {
    goToMessengerUrl() {
      window.open(this.messengerUrl)
    },

    goToDiscordUrl() {
      window.open(this.discordUrl)
    },

    goToTelegramUrl() {
      window.open(this.telegramUrl)
    },

    goToInstagramUrl() {
      window.open(this.instagramUrl)
    },

    goToWhatsApp() {
      window.open(this.whatsAppUrl)
    },

    goToSupportUrl() {
      window.open(this.supportUrl)
    },

    goToSupport() {
      if (this.messengerUrl) {
        this.goToMessengerUrl()
      } else if (this.discordUrl) {
        this.goToDiscordUrl()
      } else if (this.telegramUrl) {
        this.goToTelegramUrl()
      } else if (this.instagramUrl) {
        this.goToInstagramUrl()
      } else if (this.whatsAppUrl) {
        this.goToWhatsApp()
      } else if (this.supportUrl) {
        this.goToSupportUrl()
      }
    },
  },
}
